import { oc } from '@orpc/contract';
import { z } from 'zod';
import { commonErrors } from './common/errors.js';

const guarded = {
  UNAUTHENTICATED: commonErrors.UNAUTHENTICATED,
  PERMISSION_DENIED: commonErrors.PERMISSION_DENIED,
  TWO_FACTOR_REQUIRED: commonErrors.TWO_FACTOR_REQUIRED,
};

export const permissionEntrySchema = z.object({
  code: z.string(),
  resource: z.string(),
  action: z.string(),
});

export const permissionGroupSchema = z.object({
  resource: z.string(),
  permissions: z.array(permissionEntrySchema),
});

export type PermissionEntryDto = z.infer<typeof permissionEntrySchema>;
export type PermissionGroupDto = z.infer<typeof permissionGroupSchema>;

export const permissionContract = {
  /**
   * The whole catalogue, grouped by module, in one call. It is a bounded set of
   * typed constants rather than user data, so it is deliberately unpaginated —
   * the role editor needs every row at once to draw the matrix.
   */
  catalogue: oc
    .route({
      method: 'GET',
      path: '/permissions',
      summary: 'Permission catalogue grouped by module',
    })
    .errors(guarded)
    .input(z.object({}))
    .output(z.object({ groups: z.array(permissionGroupSchema), total: z.number().int().min(0) })),
};
